import { color, Flex, Text } from '@bfa/common-ui';
import React from 'react';
import styled from 'styled-components';

const StyledFlex = styled(Flex)`
  color: ${color('iconBoxDarkest')};
`;

const BulletedList = ({
  bulletsPoints,
}: {
  bulletsPoints?: Array<string | null> | null;
}) => {
  if (!bulletsPoints) return null;

  return (
    <Flex flexDirection="column">
      {bulletsPoints.map((point, index) => {
        if (!point) return null;
        return (
          <Flex
            key={+index}
            justifyContent="flex-start"
            marginTop="1.5rem"
            alignItems="center"
          >
            <StyledFlex
              className="icon-ipsy icon-ipsy-check-med"
              alignSelf="flex-start"
              paddingTop="0.4rem"
            />
            <Text marginLeft="1.5rem" textAlign="left">
              {point}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default BulletedList;
